import {
  type CreateMergeIntegrationLinkResponseAPI,
  type GetMergeIntegrationResponseAPI,
  type GetXeroAccountCodeMappingsResponseAPI,
  type GetXeroAccountsResponseAPI,
  type GetXeroConnectionResponseAPI,
  type GetXeroOrganisationsResponseAPI,
  MergeIntegrationEmployeeStatus,
  MergeIntegrationStatus,
  type UpdateXeroAccountCodeMappingsResponseAPI,
  XeroConnectionStatusEnum,
} from '@omnipresentgroup/types';

export const DEFAULT_INTEGRATION_RESPONSE: GetMergeIntegrationResponseAPI = {
  enabled: false,
  status: MergeIntegrationStatus.LINK_GENERATED,
  company_id: 'company_id',
  magic_link_url: 'https://merge.com/magic-link',
  integration_name: 'ApplicantStack', // integration_provider_name
  icon: {
    image:
      'https://merge-api-public.s3.amazonaws.com/media/Applicant_Stack_Logo.png',
    square_image:
      'https://merge-api-public.s3.amazonaws.com/media/ApplicantStack_Square_Logo_wBHYVRL.jpg',
  },
  employees: [],
};

export const MERGE_INTEGRATION_EMPLOYEES = [
  {
    id: 'f27cb11d-5450-4579-bdda-7bbabb22efb1',
    first_name: 'John',
    last_name: 'Doe',
    work_email: '',
    sync_status: MergeIntegrationEmployeeStatus.MISSING_OP,
    last_event_at: '2022-01-01T00:00:00Z',
  },
  {
    id: 'f27cb11d-5450-4579-bdda-7bbabb22efb1',
    first_name: 'Alice',
    last_name: 'Johnson',
    work_email: '',
    sync_status: MergeIntegrationEmployeeStatus.INVALID,
    last_event_at: '2022-01-01T00:00:00Z',
  },
  {
    id: 'f27cb11d-5450-4579-bdda-7bbabb22efb1',
    first_name: 'Bob',
    last_name: 'Brown',
    work_email: '',
    sync_status: MergeIntegrationEmployeeStatus.DUPLICATE_OP,
    last_event_at: '2022-01-01T00:00:00Z',
  },
  {
    id: 'f27cb11d-5450-4579-bdda-7bbabb22efb1',
    first_name: 'Hermione',
    last_name: 'Granger',
    work_email: '',
    sync_status: MergeIntegrationEmployeeStatus.DUPLICATE_MERGE,
    last_event_at: '2022-01-01T00:00:00Z',
  },
  {
    id: 'f27cb11d-5450-4579-bdda-7bbabb22efb1',
    first_name: 'Karen',
    last_name: 'White',
    work_email: '',
    sync_status: MergeIntegrationEmployeeStatus.NOT_CHECKED,
    last_event_at: '2022-01-01T00:00:00Z',
  },
  {
    id: 'f27cb11d-5450-4579-bdda-7bbabb22efb1',
    first_name: 'Michael',
    last_name: 'Johnson',
    work_email: '',
    sync_status: MergeIntegrationEmployeeStatus.MISSING_MERGE,
    last_event_at: '2022-01-01T00:00:00Z',
  },
  {
    id: 'f27cb11d-5450-4579-bdda-7bbabb22efb1',
    first_name: 'James',
    last_name: 'Edwards',
    work_email: '',
    sync_status: MergeIntegrationEmployeeStatus.CLIENT_AUTH_FAILURE,
    last_event_at: '2022-01-01T00:00:00Z',
  },
  {
    id: '9e5c3fef-ff66-4f8e-91a0-70fbea2d9f31',
    first_name: 'Jane',
    last_name: 'Smith',
    work_email: 'test@workemail.com',
    sync_status: MergeIntegrationEmployeeStatus.MISSING_MERGE,
    last_event_at: '2022-01-02T00:00:00Z',
  },
  {
    id: 'f27cb11d-5450-4579-bdda-7bbabb22efb1',
    first_name: 'Karen',
    last_name: 'White',
    work_email: '',
    sync_status: MergeIntegrationEmployeeStatus.NOT_CHECKED,
    last_event_at: '2022-01-01T00:00:00Z',
  },
  {
    id: 'f27cb11d-5450-4579-bdda-7bbabb22efb1',
    first_name: 'Michael',
    last_name: 'Johnson',
    work_email: '',
    sync_status: MergeIntegrationEmployeeStatus.MISSING_MERGE,
    last_event_at: '2022-01-01T00:00:00Z',
  },
  {
    id: 'f27cb11d-5450-4579-bdda-7bbabb22efb1',
    first_name: 'James',
    last_name: 'Edwards',
    work_email: '',
    sync_status: MergeIntegrationEmployeeStatus.CLIENT_AUTH_FAILURE,
    last_event_at: '2022-01-01T00:00:00Z',
  },
  {
    id: '9e5c3fef-ff66-4f8e-91a0-70fbea2d9f31',
    first_name: 'Jane',
    last_name: 'Smith',
    work_email: 'test@workemail.com',
    sync_status: MergeIntegrationEmployeeStatus.MISSING_MERGE,
    last_event_at: '2022-01-02T00:00:00Z',
  },
];

export const DEFAULT_MERGE_LINK_DEFAULT_RESPONSE: CreateMergeIntegrationLinkResponseAPI =
  {
    merge_magic_link_url: 'https://merge.com/magic-link',
    merge_magic_link_url_expiry_at: '2022-01-01T00:00:00Z',
  };

export const DEFAULT_XERO_CONNECTION_RESPONSE: GetXeroConnectionResponseAPI = {
  connection_status: XeroConnectionStatusEnum.CONNECTED,
  can_user_configure_connection: true,
  xero_organisation: {
    id: 'organisation_id',
    name: 'organisation name',
  },
};

export const DEFAULT_XERO_ORGANISATIONS_RESPONSE: GetXeroOrganisationsResponseAPI =
  {
    xero_organisations: [
      {
        id: 'organisation_id',
        name: 'organisation name',
      },
      {
        id: 'organisation_id_2',
        name: 'organisation name 2',
      },
    ],
  };

export const DEFAULT_XERO_ACCOUNTS_RESPONSE: GetXeroAccountsResponseAPI = {
  xero_accounts: [
    {
      id: 'account_code_id',
      name: 'Allowances',
      code: '0987',
      description: 'account description type',
    },
    {
      id: 'account_code_id_2',
      name: 'Insurance',
      code: '2389',
      description: 'account description type 2',
    },
    {
      id: 'account_code_id_3',
      name: 'Fees',
      code: '75982',
      description: 'account description type 3',
      tax_rate: '3.54',
    },
  ],
};

export const DEFAULT_XERO_ACCOUNT_CODE_MAPPINGS_RESPONSE: GetXeroAccountCodeMappingsResponseAPI =
  {
    account_code_mappings: [
      {
        category: {
          id: 'salary_category_id',
          name: 'salary',
        },
        xero_account_code: {
          id: 'account_code_id',
          name: 'account code name',
          code: '0987',
        },
      },
      {
        category: {
          id: 'allowance_category_id',
          name: 'allowances',
        },
        xero_account_code: {
          id: 'account_code_id_2',
          name: 'account code name 2',
          code: '2389',
        },
      },
      {
        category: {
          id: 'social_costs_category_id',
          name: 'social costs',
        },
        xero_account_code: {
          id: 'account_code_id_3',
          name: '75982',
          code: '75982',
          tax_rate: '3.54',
        },
      },
      {
        category: {
          id: 'insurance_fees_category_id',
          name: 'insurance fees',
        },
      },
      {
        category: {
          id: 'costs_category_id',
          name: 'costs fees',
        },
      },
    ],
  };

export const DEFAULT_UPDATE_XERO_ACCOUNT_CODE_MAPPINGS_RESPONSE: UpdateXeroAccountCodeMappingsResponseAPI =
  {
    account_code_mappings: [
      {
        category: {
          id: 'salary_category_id',
          name: 'salary',
        },
        xero_account_code: {
          id: 'account_code_id',
          name: 'account code name',
          tax_rate: '1.54',
          code: '0987',
        },
      },
      {
        category: {
          id: 'allowance_category_id',
          name: 'allowances',
        },
        xero_account_code: {
          id: 'account_code_id_2',
          name: 'account code name 2',
          tax_rate: '2.54',
          code: '2389',
        },
      },
      {
        category: {
          id: 'social_costs_category_id',
          name: 'social costs',
        },
        xero_account_code: {
          id: 'account_code_id_3',
          name: '75982',
          tax_rate: '3.54',
          code: '75982',
        },
      },
      {
        category_id: 'insurance_fees_category_id',
        error: {
          code: 'UNKNOWN_CATEGORY',
          description:
            'error message 1 fjajsdñfkasñd jad fjalñsdj flaksjd fkñlajsdfklñasj dfklñajsdfklñajsdfklñajskldfñjaslkdfjaslk',
        },
      },
      {
        category_id: 'costs_category_id',
        error: {
          code: 'UNKNOWN_XERO_ACCOUNT_CODE',
          description: 'error message 2',
        },
      },
    ],
  };
